const indices = [
  { label: '动作冒险', count: '1,286部' },
  { label: '喜剧搞笑', count: '892部' },
  { label: '科幻奇幻', count: '654部' },
  { label: '悬疑犯罪', count: '743部' },
  { label: '爱情剧情', count: '1,032部' },
  { label: '恐怖惊悚', count: '518部' },
  { label: '动画动漫', count: '967部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            按类型快速找到你想看的高清影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indices.map((item) => (
            <a
              key={item.label}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex flex-col items-center justify-center p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer group"
            >
              <span className="text-sm md:text-base font-semibold text-foreground-200 group-hover:text-primary-500 transition-colors mb-1 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}